import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3bbce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footerInfo-container" }
const _hoisted_2 = { class: "introduce-container global-container" }
const _hoisted_3 = { class: "introduce-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, " 地址：广东省广州市番禺区（启愉智能研发总部） ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iphone" }, "电话：13326445858", -1))
const _hoisted_7 = { class: "qr-code" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "启愉微信公众号", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信咨询", -1))
const _hoisted_14 = { class: "introduce-right" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copyright-container global-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "copyright" }, " Copyright © 2020-2026 广州启愉智能科技有限公司 版权所有 "),
  /*#__PURE__*/_createElementVNode("div", { class: "filings" }, "粤ICP备2025406286号")
], -1))

import { oss } from "@/utils/oss";
import { reactive, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterInfo',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// 每个分类对应一个页面路由，子项对应该页面内的锚点 id
const introduceData = reactive([
  {
    title: "首页",
    path: "/",
    sections: [
      { label: "企业简介", id: "about" },
      { label: "发展历程", id: "history" },
      { label: "产品与服务", id: "products" },
      { label: "数智养鱼系统", id: "system" },
    ],
  },
  {
    title: "产品介绍",
    path: "/product",
    sections: [
      { label: "产品展示", id: "product-show" },
      { label: "市场痛点", id: "pain" },
      { label: "核心优势", id: "advantages" },
      { label: "AI 养鱼管家", id: "butler" },
      { label: "智能配置", id: "spec" },
    ],
  },
  {
    title: "数字化平台",
    path: "/platform",
    sections: [
      { label: "大数据分析", id: "bigdata" },
      { label: "私域管理", id: "civic" },
      { label: "精准服务", id: "precision" },
    ],
  },
  {
    title: "定制化服务",
    path: "/customization",
    sections: [
      { label: "定制服务", id: "service" },
      { label: "部分案例", id: "cases" },
      { label: "定制流程", id: "process" },
      { label: "服务优势", id: "advantage" },
      { label: "客户反馈", id: "feedback" },
    ],
  },
  {
    title: "联系我们",
    path: "/contact",
    sections: [
      { label: "公司地址", id: "location" },
      { label: "联系方式", id: "contact-info" },
      { label: "加入我们", id: "join" },
      { label: "合作联系", id: "cooperate" },
    ],
  },
]);

// 平滑滚动到目标锚点。用原生 scrollIntoView（自动兼容 autofit 的缩放变换），
// 顶部固定导航的遮挡高度由各锚点的 scroll-margin-top 预留。
function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function goTo(path: string, id?: string) {
  if (route.path === path) {
    if (id) scrollToId(id);
    else
      (document.querySelector(".wrap") as HTMLElement | null)?.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    return;
  }
  router.push(path).then(() => {
    // 等待新页面渲染后再滚动到锚点
    nextTick(() => {
      if (id) setTimeout(() => scrollToId(id), 80);
    });
  });
}

return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "image",
          src: _unref(oss)('logo.png'),
          alt: "启愉智能 INSPIRER"
        }, null, 8, _hoisted_4),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "image-qr",
              src: _unref(oss)('home/qr-gzh.jpg')
            }, null, 8, _hoisted_9),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "image-qr",
              src: _unref(oss)('home/qr-wechat.png')
            }, null, 8, _hoisted_12),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introduceData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.title
          }, [
            _createElementVNode("h2", {
              onClick: ($event: any) => (goTo(item.path))
            }, _toDisplayString(item.title), 9, _hoisted_15),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sections, (section) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: section.id,
                  onClick: ($event: any) => (goTo(item.path, section.id))
                }, _toDisplayString(section.label), 9, _hoisted_16))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_17
  ])), [
    [_directive_reveal]
  ])
}
}

})